import { product_earphone1_1Img, product_earphone1_2Img, product_earphone1_3Img, product_earphone1_4Img } from "../../assets/image";
import { product_earphone2_1Img, product_earphone2_2Img, product_earphone2_3Img, product_earphone2_4Img } from "../../assets/image";

const mockProducts: IProduct[] = [
    {
        id: "1",
        title: "Premium Wireless Earbuds Pro",
        jpTitle: "プレミアムワイヤレスイヤホンPro",
        description: "Experience crystal-clear sound with our latest wireless earbuds. Features active noise cancellation, 24-hour battery life, and premium comfort.",
        jpDescription: "最新のワイヤレスイヤホンで crystal-clear サウンドを体験してください。アクティブノイズキャンセリング、24時間のバッテリー寿命、プレミアムな装着感を特徴としています。",
        price: 199.99,
        images: [product_earphone1_1Img, product_earphone1_2Img, product_earphone1_3Img, product_earphone1_4Img],
        features: ["Active Noise Cancellation", "24-hour Battery Life", "Water Resistant", "Touch Controls"],
        jpFeatures: ["アクティブノイズキャンセリング", "24時間バッテリー持続", "防水機能", "タッチ操作"],
        category: "Audio",
        jpCategory: "オーディオ",
        rating: 4.8,
        reviews: 128,
        stock: 50
    },
    {
        id: "2",
        title: "Smart Wireless Headphones",
        jpTitle: "スマートワイヤレスヘッドホン",
        description: "Next-generation wireless headphones with advanced AI features, premium sound quality, and seamless device switching.",
        jpDescription: "次世代のワイヤレスヘッドホンは、高度なAI機能、プレミアムサウンド品質、シームレスなデバイス切り替えを実現します。",
        price: 299.99,
        images: [product_earphone2_1Img, product_earphone2_2Img, product_earphone2_3Img, product_earphone2_4Img],
        features: ["AI Sound Optimization", "Multi-device Connection", "40-hour Battery", "Premium Build"],
        jpFeatures: ["AI音声最適化", "マルチデバイス接続", "40時間バッテリー", "プレミアム構造"],
        category: "Audio",
        jpCategory: "オーディオ",
        rating: 4.9,
        reviews: 256,
        stock: 30
    },
    {
        id: "3",
        title: "Sport Wireless Earbuds",
        jpTitle: "スポーツワイヤレスイヤホン",
        description: "Perfect for active lifestyles, these wireless earbuds feature secure fit, sweat resistance, and crystal-clear sound quality.",
        jpDescription: "アクティブなライフスタイルに最適なワイヤレスイヤホン。フィット感、汗耐性、クリアなサウンド品質を特徴としています。",
        price: 149.99,
        images: [product_earphone1_1Img, product_earphone1_2Img, product_earphone1_3Img, product_earphone1_4Img],
        features: ["Sweat Resistant", "Secure Fit", "12-hour Battery", "Voice Assistant"],
        jpFeatures: ["汗耐性", "安定したフィット感", "12時間バッテリー", "音声アシスタント"],
        category: "Audio",
        jpCategory: "オーディオ",
        rating: 4.7,
        reviews: 89,
        stock: 75
    },
    // {
    //     id: "4",
    //     title: "Premium Over-Ear Headphones",
    //     description: "Luxury over-ear headphones with premium materials, exceptional sound quality, and superior comfort for extended listening sessions.",
    //     price: 399.99,
    //     images: [product_earphone2_1Img, product_earphone2_2Img, product_earphone2_3Img, product_earphone2_4Img],
    //     features: ["Premium Sound Quality", "Memory Foam Cushions", "50-hour Battery", "Bluetooth 5.0"],
    //     category: "Audio",
    //     rating: 4.9,
    //     reviews: 167,
    //     stock: 25
    // },
    // {
    //     id: "5",
    //     title: "Wireless Earbuds Plus",
    //     description: "Versatile wireless earbuds with advanced features, perfect for both music and calls with exceptional clarity.",
    //     price: 179.99,
    //     images: [product_earphone1_1Img, product_earphone1_2Img, product_earphone1_3Img, product_earphone1_4Img],
    //     features: ["Crystal Clear Calls", "18-hour Battery", "Quick Charging", "Smart Controls"],
    //     category: "Audio",
    //     rating: 4.6,
    //     reviews: 92,
    //     stock: 60
    // }
];

export { mockProducts };
